import { useCallback, useState } from 'react';
import AuditLogTimeline from './AuditLogTimeline';

/**
 * Audit log of one resource (bookings, organizations, users, hotels, trips,
 * folders), for a tab or a section of its page. Filters stay in local state so
 * they never clash with the host page's URL.
 *
 * `fetchResourceAuditLogs(type, id, queryString)` resolves to `{ items, total }`.
 */
export default function AuditLogResource({
  type,
  id,
  fetchResourceAuditLogs,
  actions,
  perPage,
  showCount,
  embedded,
}) {
  const [params, setParams] = useState(() => new URLSearchParams());
  const fetchAuditLogs = useCallback(
    (query) => fetchResourceAuditLogs(type, id, query),
    [fetchResourceAuditLogs, type, id],
  );

  return (
    <AuditLogTimeline
      actions={actions}
      params={params}
      onParamsChange={setParams}
      fetchAuditLogs={fetchAuditLogs}
      filterable={false}
      defaultPerPage={perPage}
      showCount={showCount}
      embedded={embedded}
    />
  );
}
